module.exports = __webpack_public_path__ + "img/canvas-night-cool.8fd77428.jpg";